import { useSelector } from "react-redux";
import {
  Duration_model,
  IELTS_SCORE_SELECT_MODEL,
} from "../../Models/CoursesModel";
import RangeSlider from "../../Components/RangeSilder";
import { useState } from "react";

export default function CourseFilter({
  handleFilter,
  TableFilter,
  handleClearFilter,
  handleSliderFilter,
}) {
  const [SliderValue, setSliderValue] = useState({ min: 100, max: 60000 });
  const { Country_List } = useSelector((state) => state.COUNTRY_LIST_REDUCER);
  const { UniversityList } = useSelector(
    (state) => state.UNIVERSITY_LIST_REDUCER
  );
  const { Intake_List } = useSelector((state) => state.INTAKE_LIST_REDUCER);
  const { Course_Offered_List } = useSelector(
    (state) => state.COURSE_OFFERED_LIST_REDUCER
  );
  const { Courses_Count } = useSelector(
    (state) => state.COURSES_TOTAL_DATA_REDUCER
  );

  const handleChange = (e) => {
    setSliderValue({ min: e[0], max: e[1] });
    handleSliderFilter(e);
  };

  const handleRest = (e) => {
    e.preventDefault();
    setSliderValue({ min: 100, max: 60000 });
    handleClearFilter();
  };

  return (
    <div className="add-filter">
      <div className="filter-title  filter-title-mob">
        <h5>Filter Courses</h5>
        <button className="mob-nav-open">☰</button>
      </div>
      <div className="filter-body filter-body-mob custom-scroll-right pt-0">
        <div className="sticky pt-2">
          <h6>
            <strong>Courses Record</strong>
          </h6>
          <p style={{ marginTop: "5px" }}>
            showing {Courses_Count ? Courses_Count[0].total : 0} Courses
          </p>
        </div>
        <div className="sticky pt-2">
          <h6>
            <strong> All Filter</strong>
          </h6>
          <button
            onClick={(e) => handleRest(e)}
            className="btn btn-sm btn-deep-orange"
          >
            Clear All
          </button>
          <div>
            <ul className="modify-filter-title">
              {/* Country Filter  */}
              <li className="chose">Interested Field of Country</li>
              <li>
                <select
                  className="form-control"
                  name="Country"
                  value={TableFilter.Country}
                  onChange={handleFilter}
                >
                  <option value="">--Select--</option>
                  {Country_List?.map((el) => (
                    <option key={el.Id} value={el.Id}>
                      {el.Country}
                    </option>
                  ))}
                </select>
              </li>
              {/* University Filter  */}
              <li className="chose">University</li>
              <li>
                <select
                  className="form-control"
                  name="University"
                  value={TableFilter.University}
                  onChange={handleFilter}
                >
                  <option value="">--Select--</option>
                  {UniversityList?.map((el) => (
                    <option key={el.University_Id} value={el.University_Id}>
                      {el.University_Name}
                    </option>
                  ))}
                </select>
              </li>
              {/* Study Level Filter  */}
              <li className="chose">StudyLevel</li>
              <li>
                <select
                  className="form-control"
                  name="StudyLevel"
                  value={TableFilter.StudyLevel}
                  onChange={handleFilter}
                >
                  <option value="">--Select--</option>
                  {Course_Offered_List?.map((el) => (
                    <option key={el.Id} value={el.Id}>
                      {el.Study_Level}
                    </option>
                  ))}
                </select>
              </li>

              {/* Intake Filter  */}
              <li className="chose">Intake</li>
              <li>
                <select
                  className="form-control"
                  name="Intake"
                  value={TableFilter.Intake}
                  onChange={handleFilter}
                >
                  <option value="">--Select--</option>
                  {Intake_List?.map((el) => (
                    <option key={el.Id} value={el.Id}>
                      {el.Intake}
                    </option>
                  ))}
                </select>
              </li>
              {/* Duration Filter  */}

              <li className="chose">Duration</li>
              <li>
                <select
                  className="form-control"
                  name="duration"
                  value={TableFilter.duration}
                  onChange={handleFilter}
                >
                  <option value="">--Select--</option>
                  {Duration_model?.map((el, i) => (
                    <option key={el} value={el}>
                      {el}
                    </option>
                  ))}
                </select>
              </li>

              {/* Fees Filter  */}

              <li className="chose">Fees</li>
              <li>
                <RangeSlider
                  SliderValue={SliderValue}
                  handleChange={handleChange}
                />
              </li>
              {/* IELTS Score Filter  */}
              <li className="chose">IELTS Score</li>
              <li>
                <select
                  className="form-control"
                  name="IELTSScore"
                  value={TableFilter.IELTSScore}
                  onChange={handleFilter}
                >
                  <option value="">--Select--</option>
                  {IELTS_SCORE_SELECT_MODEL.map((el, i) => (
                    <option key={i} value={el}>
                      {el}
                    </option>
                  ))}
                </select>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}
